// import the plugin
import axios from "axios";
import store from "store";
import Vue from "vue";
import {isWebClip} from "../utils/detect";

const TOKEN_KEY = "mm-chat.token";
const REFRESH_TOKEN_KEY = "mm-chat.refresh.token";

const ENABLE_GOOGLE_AUTH = window.GOOGLE_AUTH || false;

const ERROR_CODE = {
    AUTH: 406
};

export default class {

    loadConfig() {
        return this.http.get("/auth/google/identity/config")
    }

    loadGapi() {
        if (!ENABLE_GOOGLE_AUTH) {
            return Promise.reject('google auth is not enabled');
        }
        let timeoutID = 0;

       return new Promise((done, reject) => {
            this.loadConfig()
                .then((config) => {
                    return new Promise((ok) => {
                        Vue.nextTick(() => {
                            ok(config);
                        })
                    });
                })
                .then((config) => {
                    timeoutID = setInterval(() => {
                        if (global.google) {
                            clearInterval(timeoutID);

                            this.config = config;

                            done();
                        }
                    }, 500);

                    if (!document.querySelector("#google_api_lib")) {
                        let s = document.createElement('script');
                        s.setAttribute("id", "google_api_lib");
                        s.setAttribute('src', "https://accounts.google.com/gsi/client");
                        document.head.appendChild(s);
                    }
                });
        });
    }

    init(wrapper) {
        return new Promise((resolve) => {
            if (isWebClip()) {
                this.config = {
                    ...this.config,
                    ux_mode: "redirect",
                }
            }
            google.accounts.id.initialize({
                ...this.config,
                callback(json) {
                    // console.log(json);
                    resolve(json)
                }
            });


            google.accounts.id.renderButton(
                wrapper,
                { theme: "outline", size: "large" }  // customization attributes
            );
        })
    }

    signIn(json) {
        return this.http.get("/auth/google/identity", {
            params: {
                code: json.credential || "",
            }
        }).then((data) => {
            // console.log(data);
            let token = data.token;
            store.set(TOKEN_KEY, token);
            if (data.fresh_token) {
                store.set(REFRESH_TOKEN_KEY, data.fresh_token);
            }
            return Promise.resolve(token);
        });
    }


    constructor() {
        this.api = global.API_URI || "http://mm-chat.demo2.mixmedia.com/api";

        this.http = axios.create({
            baseURL: this.api,
        });

        this.config = {

        };

        this.http.interceptors.response.use(function (resp) {
            let json = resp.data;
            if (json && json.status == 1) {
                return json.data;
            }
            if (json && json.error) {
                if (json.error.code == ERROR_CODE.AUTH) {
                }
                return Promise.reject(json.error);
            }

            return Promise.reject();
        });
    }


}
